import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, ResolveFn } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { MessagesService } from '@app/layout/common/messages/messages.service';
import { NavigationService } from '@app/core/navigation/navigation.service';
import { NotificationsService } from '@app/layout/common/notifications/notifications.service';
import { ShortcutsService } from '@app/layout/common/shortcuts/shortcuts.service';
import { UserService } from '@app/core/user/user.service';

/**
 * Initial data resolver function
 * Use this resolver to resolve initial mock-api for the application
 */
export const initialDataResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const shortcutsService = inject(ShortcutsService);
    const userService = inject(UserService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        // messagesService.getAll(),      // @Removed as don't need to worry yet
        // notificationsService.getAll(), // @Removed as don't need to worry yet
        // shortcutsService.getAll(),     // @Removed as don't need to worry yet
        userService.get()
    ]);
};

// Legacy class-based resolver (deprecated - use functional resolver above)
// @deprecated Use initialDataResolver instead
export { initialDataResolver as InitialDataResolver }
